import { TextField } from "@mui/material";
import { SharedFieldInputProps } from "./types";

interface TextFieldInputProps extends SharedFieldInputProps<string | null> {
    multiline?: boolean;
    minRows?: number;
    maxRows?: number;
}

export function TextFieldInput({
    value,
    onChange,
    error = false,
    helperText,
    autoFocus = false,
    fullWidth = true,
    size = "small",
    disabled = false,
    multiline = false,
    minRows,
    maxRows,
}: TextFieldInputProps) {
    return (
        <TextField
            value={value ?? ""}
            onChange={(event) => onChange(event.target.value)}
            error={error}
            helperText={helperText}
            autoFocus={autoFocus}
            fullWidth={fullWidth}
            size={size}
            disabled={disabled}
            multiline={multiline}
            minRows={minRows}
            maxRows={maxRows}
        />
    );
}
